<svelte:options
  customElement={{
    tag: 'teo-debug',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import DebugComponent from '@/ui/components/debug/DebugComponent.svelte';
  import { TeoProvider } from '@/utils/teo-context';

  import type { TeoCore } from '../teoCore/TeoCore';
  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore: TeoCore } = $props();

  let visible = $state(false);
</script>

<TeoProvider {teoCore}>
  <div
    class="h-[calc(100%-70px)] transition-transform
{visible ? 'w-[330px] translate-x-[-330px]' : 'w-[30px] translate-x-[-30px] overflow-hidden'}"
  >
    <button
      class="absolute left-[-9px] top-[80px] inline-block -rotate-90 bg-tooltip-S p-1"
      onclick={() => (visible = !visible)}
    >
      Debug</button
    >
    <div class="ml-[30px] mt-[70px] h-full overflow-auto bg-tooltip-S p-2">
      <DebugComponent />
    </div>
  </div>
</TeoProvider>
